const types = {
  GET_LIST_CLIENTS_MRKT: 'GET_LIST_CLIENTS_MRKT',
};
export default types;
